export default __webpack_public_path__ + "./images/noInternet.8301fbfa.svg";